import { getPrivacyProfile } from '../config/privacy';

export const DISPLAY_PROFILE_URL =
  process.env.REACT_APP_INTERNAL_DISPLAY_PROFILE_URL ||
  '/api/display-profile';

export async function fetchDisplayProfile({ signal, fetchImpl } = {}) {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.REACT_APP_DEV_SHOW_MESSAGES === 'true'
  ) {
    return getPrivacyProfile(true);
  }
  const request = fetchImpl || (typeof fetch === 'function' ? fetch : null);
  if (!request) {
    return getPrivacyProfile(false);
  }

  try {
    const response = await request(DISPLAY_PROFILE_URL, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal
    });
    if (!response.ok) {
      return getPrivacyProfile(false);
    }
    const payload = await response.json();
    return getPrivacyProfile(payload?.showsMessagesPanel === true);
  } catch {
    return getPrivacyProfile(false);
  }
}
